import { render, staticRenderFns } from "./FullNews.vue?vue&type=template&id=02055903&scoped=true&"
import script from "./FullNews.vue?vue&type=script&lang=js&"
export * from "./FullNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02055903",
  null
  
)

export default component.exports